module.exports = __webpack_public_path__ + "img/艾匹柯流体设备盐智钉项目启动会.64421fb3.jpg";